import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=d2c0f256&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=d2c0f256&prod&scoped=true&lang=css"
import style1 from "./Question.vue?vue&type=style&index=1&id=d2c0f256&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c0f256",
  null
  
)

export default component.exports